module.exports = __webpack_public_path__ + "img/cover_whd.859708c7.jpg";